import { useAuth } from '../hooks/useAuth';
import { mdiAutoFix, mdiCalendarMonthOutline, mdiChartBoxOutline, mdiNoteTextOutline, mdiGauge, mdiTrophyOutline, mdiBookshelf, mdiTimerOutline } from '@mdi/js';
import React, { useCallback, useLayoutEffect, useRef, useState } from 'react';

import { useLocation, useNavigate } from 'react-router-dom';

import { useTranslation } from 'react-i18next';

import {
  IoAdd,
  IoAnalytics,

  IoAnalyticsOutline,


  IoCalendar,

  IoCalendarOutline,


  IoHome,

  IoHomeOutline,



  IoTrophy,

  IoTrophyOutline,

} from 'react-icons/io5';





import { useAthleteContext } from '../context/AthleteContext';



type TabName = 'calendar' | 'home' | 'charts' | 'records';



type FabAction = {

  id: string;

  labelKey: string;

  iconBg: string;

  iconColor: string;

  icon: React.ReactNode;

  route: string;

};



function FabIcon({ path }: { path: string }) {
  return <svg width={22} height={22} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" focusable="false"><path d={path} /></svg>;
}

const FAB_ACTIONS: FabAction[] = [
  { id: 'ai-assistant', labelKey: 'assistant.title', iconBg: 'var(--surface-0)', iconColor: '#579fff', icon: <FabIcon path={mdiAutoFix} />, route: '/ai-assistant' },

  {

    id: 'atp',

    labelKey: 'fab.atp',

    iconBg: 'var(--vo2-green-500)',

    iconColor: '#fff',

    icon: <FabIcon path={mdiCalendarMonthOutline} />,

    route: '/atp',

  },

  {

    id: 'batchCompare',

    labelKey: 'fab.batchCompare',

    iconBg: '#e60a86',

    iconColor: '#ffffff',

    icon: <FabIcon path={mdiChartBoxOutline} />,

    route: '/batch-compare',

  },

  {

    id: 'note',

    labelKey: 'fab.note',

    iconBg: '#ffffff',

    iconColor: '#000000',

    icon: <FabIcon path={mdiNoteTextOutline} />,

    route: '/calendar/note/new',

  },

  {

    id: 'metric',

    labelKey: 'fab.metric',

    iconBg: '#ffffff',

    iconColor: '#000000',

    icon: <FabIcon path={mdiGauge} />,

    route: '/calendar/metric/new',

  },

  {

    id: 'event',

    labelKey: 'fab.event',

    iconBg: '#007a7a',

    iconColor: '#ffffff',

    icon: <FabIcon path={mdiTrophyOutline} />,

    route: '/calendar/event/new',

  },

  {

    id: 'library',

    labelKey: 'fab.library',

    iconBg: '#910f92',

    iconColor: '#ffffff',

    icon: <FabIcon path={mdiBookshelf} />,

    route: '/library',

  },

  {

    id: 'workout',

    labelKey: 'fab.workout',

    iconBg: '#015592',

    iconColor: '#ffffff',

    icon: <FabIcon path={mdiTimerOutline} />,

    route: '/calendar/workout/new',

  },

];

// Keep the batch comparison feature and route intact, but hide its FAB entry
// until it is ready to be exposed again.
const VISIBLE_FAB_ACTIONS = FAB_ACTIONS.filter((action) => action.id !== 'batchCompare');



const TAB_ICONS: Record<

  TabName,

  { active: React.ReactNode; inactive: React.ReactNode }

> = {

  calendar: {

    active: <IoCalendar size={22} />,

    inactive: <IoCalendarOutline size={22} />,

  },

  home: {

    active: <IoHome size={22} />,

    inactive: <IoHomeOutline size={22} />,

  },

  charts: {

    active: <IoAnalytics size={22} />,

    inactive: <IoAnalyticsOutline size={22} />,

  },

  records: {

    active: <IoTrophy size={22} />,

    inactive: <IoTrophyOutline size={22} />,

  },

};



function TabIcon({ name, active }: { name: TabName; active: boolean }) {

  return (

    <span className={`mobile-tab-icon${active ? ' mobile-tab-icon--active' : ''}`}>

      {active ? TAB_ICONS[name].active : TAB_ICONS[name].inactive}

    </span>

  );

}



export function MobileTabBar() {
  const { user } = useAuth();

  const { t } = useTranslation();

  const navigate = useNavigate();

  const location = useLocation();

  const { coachMenuLocked } = useAthleteContext();

  const [fabOpen, setFabOpen] = useState(false);

  const navRef = useRef<HTMLElement>(null);

  const tabBtnRefs = useRef<Partial<Record<TabName, HTMLButtonElement | null>>>({});

  const [indicatorX, setIndicatorX] = useState(0);

  const [indicatorReady, setIndicatorReady] = useState(false);



  const path = location.pathname;

  const tab: TabName =

    path.startsWith('/home') ? 'home' :

    path.startsWith('/charts') ? 'charts' :

    path.startsWith('/records') ? 'records' :

    path.startsWith('/settings') ? 'home' :

    'calendar';



  const syncIndicator = useCallback(() => {

    const nav = navRef.current;

    const btn = tabBtnRefs.current[tab];

    if (!nav || !btn) return;

    const navRect = nav.getBoundingClientRect();

    const btnRect = btn.getBoundingClientRect();

    setIndicatorX(btnRect.left - navRect.left + btnRect.width / 2);

    setIndicatorReady(true);

  }, [tab]);



  useLayoutEffect(() => {

    syncIndicator();

    const nav = navRef.current;

    if (!nav) return;

    const ro = new ResizeObserver(syncIndicator);

    ro.observe(nav);

    window.addEventListener('resize', syncIndicator);

    return () => {

      ro.disconnect();

      window.removeEventListener('resize', syncIndicator);

    };

  }, [syncIndicator]);



  const go = (to: string, locked?: boolean) => {

    if (locked && coachMenuLocked) {

      window.alert(t('coach.addAthleteFirst'));

      return;

    }

    setFabOpen(false);

    navigate(to);

  };



  return (

    <>

      {fabOpen && (

        <button type="button" className="fab-backdrop" aria-label="Close menu" onClick={() => setFabOpen(false)} />

      )}



      {fabOpen && (

        <div className="fab-menu">

          {VISIBLE_FAB_ACTIONS.filter(action => action.id !== 'ai-assistant' || (user?.id === 5 && user.role === 'coach')).map((action) => (

            <button

              key={action.id}

              type="button"

              className="fab-menu-item"

              onClick={() => {
                go(action.route, action.id !== 'atp');
              }}

            >

              <span className="fab-menu-item__label">{t(action.labelKey)}</span>

              <span

                className="fab-menu-item__icon"

                style={{ backgroundColor: action.iconBg, color: action.iconColor }}

              >

                {action.icon}

              </span>

            </button>

          ))}

        </div>

      )}



      <div className="mobile-tab-bar-wrap">

        <nav
          ref={navRef}
          className="mobile-tab-bar"
          aria-label="Main"
          style={{ ['--tab-indicator-x' as string]: `${indicatorX}px` }}
        >
          <span
            className={`mobile-tab-bar__indicator${indicatorReady ? ' mobile-tab-bar__indicator--visible' : ''}`}
            aria-hidden
          />
          <button
            type="button"
            ref={(el) => {
              tabBtnRefs.current.home = el;
            }}
            className={`mobile-tab-btn${tab === 'home' ? ' mobile-tab-btn--active' : ''}`}
            onClick={() => go('/home')}
            aria-label={t('tabs.home')}
            aria-current={tab === 'home' ? 'page' : undefined}
          >
            <TabIcon name="home" active={tab === 'home'} />
          </button>
          <button
            type="button"
            ref={(el) => {
              tabBtnRefs.current.calendar = el;
            }}
            className={`mobile-tab-btn${tab === 'calendar' ? ' mobile-tab-btn--active' : ''}`}
            disabled={coachMenuLocked}
            onClick={() => go('/calendar')}
            aria-label={t('tabs.calendar')}
            aria-current={tab === 'calendar' ? 'page' : undefined}
          >
            <TabIcon name="calendar" active={tab === 'calendar'} />
          </button>
          <button
            type="button"

            className={`mobile-fab${fabOpen ? ' mobile-fab--open' : ''}${coachMenuLocked ? ' mobile-fab--locked' : ''}`}

            onClick={() => {

              if (coachMenuLocked) {

                window.alert(t('coach.addAthleteFirst'));

                return;

              }

              setFabOpen((o) => !o);

            }}

            aria-label={t('fab.add')}

            aria-expanded={fabOpen}

          >
            <IoAdd className="mobile-fab__icon" size={28} />
          </button>

          <button

            type="button"

            ref={(el) => {
              tabBtnRefs.current.charts = el;
            }}

            className={`mobile-tab-btn${tab === 'charts' ? ' mobile-tab-btn--active' : ''}`}

            disabled={coachMenuLocked}

            onClick={() => go('/charts')}

            aria-label={t('tabs.charts')}

            aria-current={tab === 'charts' ? 'page' : undefined}

          >

            <TabIcon name="charts" active={tab === 'charts'} />

          </button>

          <button

            type="button"

            ref={(el) => {
              tabBtnRefs.current.records = el;
            }}

            className={`mobile-tab-btn${tab === 'records' ? ' mobile-tab-btn--active' : ''}`}

            disabled={coachMenuLocked}

            onClick={() => go('/records')}

            aria-label={t('tabs.records')}

            aria-current={tab === 'records' ? 'page' : undefined}

          >

            <TabIcon name="records" active={tab === 'records'} />

          </button>

        </nav>

      </div>

    </>

  );

}

